import Vuex from 'vuex'
import { getField, updateField } from 'vuex-map-fields';
import router from '@/router'
import {client, setHeaders, query_dispatcher} from "@/api/client";
import axios from 'axios';
import vuetify from '../plugins/vuetify';
import {Auth} from 'aws-amplify'
import { resolve } from 'mathjs';

export function buildStore(modules, state, debug, extraGetters, extraActions){
    return new Vuex.Store({
      strict: debug,
      modules: modules,
      state: state,
      getters: {
        ...extraGetters,
        colors(state, getters, rootState, rootGetters) {
          var result = {};
          state.labels[rootGetters["documents/annotationLayer"]].forEach(label => {
            result[label.name] = label.color;
          });
          return result;
        },
        availableTags(state, _, __, rootGetters) {
          var result = []
          state.labels[rootGetters["documents/annotationLayer"]].forEach(v => result.push({ value: v.name, text: v.text }))
          return result
        },
        
        get_companies(state) {
          // bus.$emit('refresh');
          return state.companies
        },
        get_companydbs(state) {
          return state.companydbs;
        },
        get_delegations(state){
          return state.delegations
        },
        get_projects(state){
          return state.projects
        },
        get_suppliers(state) {
          return state.suppliers
        },
        get_customers(state) {
          return state.customers
        },
        get_tags(state) {
          return state.tags
        },
        getLabels(state, _, __, rootGetters) {
          return state.labels[rootGetters["documents/annotationLayer"]]
        },
        getSessionInformation(state){
          return state.session_information;
        },
        getCurrentCompany(state) {
          return state.currentCompany;
        },
        got_feature:(state)=>(code)=>{
          if (state.currentCompany && state.currentCompany.available_features){
            return !!state.currentCompany.available_features[code]
          }
          else{
            return false
          }
        },
        getField,
        get_retention_types(state) {
          return state.retentionTypes;
        },
        get_retention_types_docs(state) {
          return state.docRetentionTypes;
        },
        get_automatic_payment_account_types(state){
          return state.automaticPaymentAccountTypes;
        },
        fetching_companydbs (state){
          return state.fetching_companydbs
        },
        get_dashboard_data (state) {
          return state.dashboard_data;
        },
        supplierRowsPerPage: state => state.supplierRowsPerPage,
        customerRowsPerPage: state => state.customerRowsPerPage,
        docStates: state => state.docStates,
        is_mobile () {
          return ['xs', 'sm'].includes(vuetify.framework.breakpoint.name);
        },
        screen_size () {
          return vuetify.framework.breakpoint.name;
        },
        fixMotxo (state){
          //return false;
          //return state.session_information.hasOwnProperty('username') && (['test.toni','support.gemma','support.mauro','coneptum'].includes(state.session_information.username))
          return state.session_information.hasOwnProperty('username') && (['coneptum'].includes(state.session_information.username))
        },
        labels(state) {
          return state.labels;
        },
        getIntActivities(state){
          const activities = JSON.parse(JSON.stringify(state.activities));
          activities.map(activity => {
            activity.code = parseInt(activity.code)
          })
          return activities
        },
        getExpensType(state) {
          return state.expens_type;
        },
        getIncomeType(state) {
          return state.income_type;
        },
        hasWorkingHoursContract(state) {
          return state.hasWorkingHoursContract;
        },
        hasEverHadWorkingHoursContract(state) {
          return state.hasEverHadWorkingHoursContract;
        },
        hasExpiredWorkingHoursContract(state) {
          return state.hasExpiredWorkingHoursContract;
        },
      },
    
      mutations: {
        // SET_CURRENT_DOC(state, doc) {
        //   state.currentDoc = doc
        // },
    
        // SET_SELECTED_TEXT(state, i) {
        //   state.selectedText = i
        //   if (i !== null && state.selectedLabel !== null) {
        //     state.currentDoc['text_tagging'][i].label[state.annotationLayer] = state.selectedLabel
        //     if (!['error_validating_data', 'error_checking_taxes'].includes(state.currentDoc.state)) {
        //       state.currentDoc.state = 'pending_review'
        //     }
        //   }
        // },
    
        // SET_DOC_ID(state, docId) {
        //   state.docId = docId
        // },
        // SET_WRITING(state, val) {
        //   state.writing = val
        // },
        // SET_CREATING_MOVES(state, val) {
        //   state.creating_moves = val
        // },
        SET_CURRENT_PAGE(state, num) {
          state.currentPage = num;
        },
        SET_IS_LOGGED(state, isLogged){
          state.isLogged = isLogged;
        },
        SET_IS_LOGGED_PROMISE(state, promise){
          state.isLoggedPromise = promise;
        },
        ADD_LABEL(state, label) {
          state.nextLabel = label;
        },
        ADD_LABEL_DONE(state, label) {
          state.nextLabel = label;
        },
        SET_SEARCH(state, search) {
          state.search_state = search
        },
        // SET_SELECTED_LABEL(state, label) {
        //   state.selectedLabel = label
        // },
        // SET_DOC_FETCHED(state, val) {
        //   state.docFetched = val
        // },
    
        // INC_LABEL(state, delta) {
        //   if (state.selectedLabel === null) {
        //     state.selectedLabel = state.labels[state.annotationLayer][0].name
        //   } else {
        //     const newIndex = (state.labels.findIndex(x => x.name === state.selectedLabel) + delta + state.labels[state.annotationLayer].length) % state.labels[state.annotationLayer].length
        //     state.selectedLabel = state.labels[state.annotationLayer][newIndex].name
        //   }
        // },
    
        // SET_CURRENT_DOC_STATE(state, value) {
        //   if (state.currentDoc) {
        //     state.currentDoc.state = value
        //   }
        // },
        SET_COMPANIES(state, value) {
          state.companies = value
        },
        SET_COMPANY_DBS(state, value) {
          console.log('SET_COMPANY_DBS!!!!',value.length)
          state.companydbs = value
        },
        SET_PROJECTS(state, value) {
          state.projects = value
        },
        SET_CHANNELS(state, value) {
          state.channels = value;
        },
        SET_ACTIVITIES(state, value) {
          state.activities = value
        },
        SET_SECTIONS(state, value) {
          state.sections = value
        },
        SET_DELEGATIONS(state, value) {
          state.delegations = value
        },
        SET_DEPARTMENTS(state, value) {
          state.departments = value
        },
        SET_EXPENS_TYPE(state, value) {
          state.expens_type = value;
        },
        SET_INCOME_TYPE(state, value) {
            state.income_type = value;
        },
        SET_SUPPLIERS(state, value) {
          state.suppliers = value
        },
        SET_CUSTOMERS(state, value) {
          state.customers = value
        },
        SET_CURRENT_COMPANY(state, value) {
          state.currentCompany = value
        },
        SET_SESSION_INFORMATION(state, value){
          state.session_information = value
        },
        SET_TAGS(state, value) {
          state.tags = value
        },
        updateField,
        SET_RETENTION_TYPES(state, value) {
          state.retentionTypes = value
        },
        SET_DOC_RETENTION_TYPES(state, value) {
          //state.docRetentionTypes = value
        },
        SET_AUTOMATIC_PAYMENT_ACCOUNT_TYPES(state, value) {
          //state.automaticPaymentAccountTypes = value
        },
        FETCHING_COMPANY_DBS(state, value){
          state.fetching_companydbs = value
        },
        SET_DASHBOARD_DATA(state, value) {
          state.dashboard_data = value;
        },
        SET_SUPPLIER_ROWS_PER_PAGE(state, value) {
          state.supplierRowsPerPage = value;
        },
        SET_CUSTOMER_ROWS_PER_PAGE(state, value) {
          state.customerRowsPerPage = value;
        },
        SET_OBJECT_LIST_ITEMS(state, value) {
          state.objectListItems = value;
        },
        SET_OBJECT_LIST_ITEMS_LENGTH(state, value) {
          state.objectListItemsLength = value;
        },
        SET_OBJECT_LIST_LOADING(state, value) {
          state.objectListLoading = value;
        },
        UNSELECT_OBJECT_LIST_SELECTED(state) {
          state.objectListSelected = [];
        },
        SET_OBJECT_LIST_FILTERS(state, value) {
          state.objectListFilters = value;
        },
        SET_BROWSER_FILTS(state, value) {
          state.browserFilts = value;
        },
        SET_BROWSER_FILTERS_VALUE(state, {i, value}) {
          state.browserFiltersValues[i] = value;
        },
        SET_ZONES(state, { current_company_id, userData, permission, got_feature, can_see_trial_contract_of_electron_invoice, can_see_module_of_electron_invoice, hasWorkingHoursContract, showTrialWorkingHours, hasEverHadWorkingHoursContract, hasExpiredWorkingHoursContract, custom_types}) {
          const isLoginAs = state.session_information && userData.username && state.session_information.username != userData.username;

          // Helper function to validate electronic invoice permissions
          const canViewTrialElectronicInvoice = () => {
            return can_see_trial_contract_of_electron_invoice && (permission.is_owner || permission.is_customer)
          };
          const canViewElectronicInvoice = () => {
            return userData.available_features
            && userData.can_view_e_invoice
            && !got_feature('feature_hide_e_invoices')
            && (
              can_see_module_of_electron_invoice  // Todos ven el módulo si hay contrato
              || canViewTrialElectronicInvoice()  // Trial solo owner y cliente
            );
          };
          const linkForElectronicInvoice = () => {
            if(current_company_id){
              if(canViewTrialElectronicInvoice()){
                return `/${current_company_id}/invoice-trial`
              } else {
                return `/${current_company_id}/invoice-list`
              }
            }else {
              if(canViewTrialElectronicInvoice()){
                return '/invoice-trial'
              } else {
                return '/invoice-list'
              }
            }
          };

          const route = window.location.pathname
          if(route.includes('invoice-trial') || route.includes('invoice-list')){
            const link = linkForElectronicInvoice();
            router.push(link);
          }

          // Helper function to validate working hours permissions
          const canViewWorkingHours = () => {
            return got_feature('feature_clock_in')
              && userData.available_features
              && userData.can_view_working_hours
              && !got_feature('feature_hide_working_hours')
              && (
                hasWorkingHoursContract  // Todos ven el módulo si hay contrato
                || (showTrialWorkingHours && (permission.is_owner || permission.is_customer))  // Trial solo owner y cliente
              );
          };
          let zones = [
            {
              heading: "Documentos",
              items: [
                {
                  icon: "mdi-file-document-outline",
                  img: "/navigation/invoices.svg",
                  text: "Contabilidad",
                  link: current_company_id ? `/${current_company_id}/documents` : '/documents',
                  shouldShow: userData.can_view_invoices && !got_feature('feature_hide_invoices'),
                }
              ]
            },
            {
              heading: "Empresas",
              items: [
                {
                  icon: "mdi-card-account-details-outline",
                  img: "/navigation/suppliers.svg",
                  text: "Proveedores",
                  link: current_company_id ? `/${current_company_id}/suppliers` : '/suppliers',
                  shouldShow: !permission.is_readonly && !got_feature('feature_hide_invoices') && (permission.general.can_admin || permission.is_employee) && !got_feature('feature_move_thirds_to_accounting'),
                },
                {
                  icon: "mdi-folder-account-outline",
                  img: "/navigation/clients.svg",
                  text: "Clientes",
                  link: current_company_id ? `/${current_company_id}/customers` : '/customers',
                  shouldShow: !permission.is_readonly && !got_feature('feature_hide_out_invoice') && !got_feature('feature_hide_invoices') && (permission.general.can_admin || permission.is_employee) && !got_feature('feature_move_thirds_to_accounting'),
                },
                {
                  icon: "mdi-bank",
                  img: "/navigation/banks.svg",
                  text: "Bancos",
                  new_label: true,
                  link: current_company_id ? `/${current_company_id}/bank-accounts` : '/banks',
                  shouldShow: userData.can_view_banks && (
                      got_feature('feature_bank_csv') ||
                      (got_feature('feature_can_user_bank_account') && !got_feature('feature_hide_banks'))
                  ),
                },
                {
                  icon: "mdi-invoice-list",
                  img: "/navigation/factura_e.svg",
                  text: "Factura electrónica",
                  new_label: canViewTrialElectronicInvoice(),
                  link: linkForElectronicInvoice(),
                  shouldShow: canViewElectronicInvoice(),
                },
                {
                  icon: "mdi-file-document-outline",
                  img: "/navigation/documents.svg",
                  text: got_feature("feature_gestor_label_documentos") ? "Documentos" : "Gestor IA",
                  new_label: true,
                  link: current_company_id ? `/${current_company_id}/generic-documents/` : '/generic-documents/',
                  shouldShow: userData.can_view_gestor && userData.available_features && userData.available_features.feature_other_documents,
                },
                {
                  icon: "mdi-warehouse",
                  //img: "/navigation/documents.svg",
                  text: "Mis Registros",
                  new_label: true,
                  link: current_company_id ? `/${current_company_id}/entities-list/` : '/entities-list/',
                  shouldShow: (!got_feature('feature_disable_mis_registros') || isLoginAs) && (userData.can_view_gestor && userData.available_features && userData.available_features.feature_other_documents || userData.is_staff && got_feature('feature_dashboard_kpis')),
                },
                {
                  icon: "mdi-calendar-clock",
                  text: "Control Horario",
                  new_label: showTrialWorkingHours && !permission.is_employee,
                  link: current_company_id
                    ? `/${current_company_id}/${hasWorkingHoursContract || permission.is_employee ? 'working-hours' : 'working-hours-trial'}`
                    : `/${hasWorkingHoursContract || permission.is_employee ? 'working-hours' : 'working-hours-trial'}`,
                  shouldShow: canViewWorkingHours(),
                },
                {
                    icon: "mdi-chart-line",
                    text: "Panel de Control",
                    new_label: true,
                    link: current_company_id ? `/${current_company_id}/dashboard` : '/dashboard',
                    shouldShow: got_feature('feature_dashboard_kpis'),
                }
              ],
            },
            {
              heading: "Tipos personalizados",
              items: custom_types
            },
            {
              heading: "Ajustes",
              items: [
                {
                  icon: "mdi-cog-outline",
                  img: "/navigation/settings.svg",
                  text: "Ajustes",
                  link: "/settings",
                  shouldShow: userData.available_features && (userData.available_features.feature_config_settings) && !got_feature('feature_hide_invoices'),
                },
                {
                  icon: "mdi-trash-can-outline",
                  img: "/navigation/delete.svg",
                  text: "Papelera",
                  link: current_company_id ? `/${current_company_id}/deleted-documents` : '/deleted-documents',
                  shouldShow: userData.available_features && userData.available_features.feature_deleted_documents && !got_feature('feature_hide_invoices'),
                },
              ]
            },
            
          ];
          zones.forEach(zone => {
            zone.items.forEach(item => {
              if (userData && userData.user_role && userData.user_role.value === "customer_other_docs") {
                if (item.text === "Documentos" && userData.available_features && userData.available_features.feature_other_documents) {
                  item.shouldShow = true;
                } else {
                  item.shouldShow = false;
                }
              }
            });
          });
          state.zones = zones;
          state.hasWorkingHoursContract = hasWorkingHoursContract;
          state.hasEverHadWorkingHoursContract = hasEverHadWorkingHoursContract;
          state.hasExpiredWorkingHoursContract = hasExpiredWorkingHoursContract;
        },
        SET_USER_ITEMS(state, user_items) {
          state.user_items = user_items;
        }, 
        SET_SELL_TERMS_DIALOG(state, sellTermsDialog) {
          state.sellTermsDialog = sellTermsDialog;
        },
        SET_MENU(state, menu) {
          state.menu = menu;
        },
        SET_OAUTH_URL(state,oauth_url){
          state.oauth_url = oauth_url;
        },
        SET_OAUTH_MSG(state, oauth_msg) {
          state.oauth_msg = oauth_msg
        },
        SET_DEFAULT_ACTIVITY(state,default_activity){
          state.default_activity = default_activity
        },
        SET_DEFAULT_CHANNEL(state,default_channel){
          state.default_channel = default_channel;
        },
        SET_OAUTH_PARAMS_STORAGE(state,oauth_params_storage){
          state.oauth_params_storage = oauth_params_storage
        },
        SET_EXE_LINK(state, link) {
          state.exe_link = link;
        },
        SET_TOTAL_LENGTH_ITEMS(state, value) {
          state.totalLengthItems = Number(value) || 0;
        },
      },
    
      actions: {
        ...extraActions,
        async waitForLoggedIn({state}){
          try {
            await state.isLoggedPromise;
            let isLogged = false;
            if (state.isLogged === 'yes') {
              isLogged = true;
            }
            return isLogged;
          } catch {
            return false;
          }
        },
    
        async setExeLink({ commit }) {
            let response = await client.get('python_files/?limit=1&version__startswith=c');
            if (response.data && response.data.results && response.data.results[0]) {
                commit("SET_EXE_LINK", response.data.results[0]['python_exe']);
            }
        },
    
        async setZones({ commit, rootGetters }, current_company_id) {
          const userData = rootGetters['me/userData'];
          const permission = rootGetters["permissions/permission"];
          const got_feature = rootGetters["got_feature"];
          let args = { company_id: current_company_id, user_id: userData.id};
          let res = await query_dispatcher.dispatch('check.if.has.permission.to.electronic.invoice', args)
          let can_see_trial_contract_of_electron_invoice = res['can_see_trial_contract_of_electron_invoice']
          let can_see_module_of_electron_invoice = res['can_see_module_of_electron_invoice']
          // Check working hours contract
          let workingHoursRes = await query_dispatcher.dispatch('check.user.has.active.working.hours.contract', { user_id: userData.id, company_id: current_company_id})
          let hasWorkingHoursContract = workingHoursRes['company']
          let showTrialWorkingHours = !workingHoursRes['company']
          let hasEverHadWorkingHoursContract = workingHoursRes['ever_had_contract'] || false
          let hasExpiredWorkingHoursContract = workingHoursRes['is_expired'] || false

          let custom_types = []
          if (got_feature("feature_entity_type_menu_items")){
            custom_types = await query_dispatcher.dispatch("get.main.custom.types", {})
            for(let ct of custom_types){
              ct.shouldShow = true;
              ct.link = ct.link.replace(':companydb_id', current_company_id);
            }
          }
          commit('SET_ZONES', {current_company_id, userData, permission, got_feature, can_see_trial_contract_of_electron_invoice, can_see_module_of_electron_invoice, hasWorkingHoursContract, showTrialWorkingHours, hasEverHadWorkingHoursContract, hasExpiredWorkingHoursContract, custom_types});
        },
    
        setCurrentPage(context, num) {
          context.commit('SET_CURRENT_PAGE', num);
        },
        addLabel(context, label) {
          context.commit('ADD_LABEL', label);
        },
        addLabelDone(context) {
          context.commit('ADD_LABEL_DONE');
        },
        setSearch(context, search) {
          context.commit('SET_SEARCH', search)
        },
        fixCompanyCIF(context, {company_id,cif,url}){
          return new Promise((resolve, reject) => {
            client.patch(url + company_id + '/',{cif:cif}).then(() => {
              resolve()
            }).catch(err=>{
              reject(err)
            });
          })
        },
        setProjects(context, companydb_id) {
          if(client){
            client.get('projects/?limit=2000&companydb_id='+companydb_id).then(response => {
              context.commit('SET_PROJECTS', response.data.results)
            });
          }
        },
        setChannels(context, companydb_id) {
          if(client){
            client.get('channels/?limit=1000&companydb_id='+companydb_id).then(response => {
              context.commit('SET_CHANNELS', response.data.results)
            });
          }
        },
        setActivities(context, companydb_id) {
          if(client){
            client.get('activities/?limit=1000&companydb_id='+companydb_id).then(response => {
              context.commit('SET_ACTIVITIES', response.data.results)
              context.dispatch("documents/setFiltersDataActividadStrValues", response.data.results);
              context.dispatch("documents/setFiltersDataActividadValues", response.data.results)
            });
          }
        },
        setSections(context, companydb_id) {
          if(client){
            client.get('sections/?limit=1000&companydb_id='+companydb_id).then(response => {
              context.commit('SET_SECTIONS', response.data.results)
            });
          }
        },
        setDelegations(context, companydb_id) {
          if(client){
            client.get('delegations/?limit=1000&companydb_id='+companydb_id).then(response => {
              context.commit('SET_DELEGATIONS', response.data.results)
            });
          }
        },
        setDepartments(context, companydb_id) {
          if(client){
            client.get('departments/?limit=1000&companydb_id='+companydb_id).then(response => {
              context.commit('SET_DEPARTMENTS', response.data.results)
            });
          }
        },
        setExpensIncomeType(context, companydb_id) {
          if(client){
            client.get('expens_income_types/?limit=1000&companydb_id='+companydb_id).then(response => {
              context.commit('SET_EXPENS_TYPE', response.data.results.filter(item => item.type === 'expens'))
              context.commit('SET_INCOME_TYPE', response.data.results.filter(item => item.type === 'income'))
            });
          }
        },
        saveActivities({ commit, dispatch }, { activities }) {
          commit('SET_ACTIVITIES', activities);
          dispatch("documents/setFiltersDataActividadStrValues", activities);
          dispatch("documents/setFiltersDataActividadValues", activities);
        },
    
        setSuppliers(context, companydb_id) {
          if(client){
            client.get('get_all_suppliers/?companydb_id=' + companydb_id).then(response => {
              context.commit('SET_SUPPLIERS', response.data.results)
            });
          }
        },
        setSupps(context, suppliers) {
          context.commit('SET_SUPPLIERS', suppliers)
        },
        setCustomers(context, companydb_id) {
          if(client){
            client.get('get_all_customers/?companydb_id=' + companydb_id).then(response => {
              context.commit('SET_CUSTOMERS', response.data.results)
            });
          }
        },
        setCusts(context, customers) {
          context.commit('SET_CUSTOMERS', customers)
        },
        setTags(context, companydb_id) {
          if(client){
            client.get('tags/?limit=100').then(response => {
              context.commit('SET_TAGS', response.data.results)
            });
          }
        },
        setCurrentCompany(context, company) {
          context.commit('SET_CURRENT_COMPANY', company);
          if(company && company.configuration){
            context.commit('SET_DEFAULT_ACTIVITY', company.configuration.actividad);
          }
          if (company) {
            context.commit('SET_DEFAULT_CHANNEL', company.default_channel);
            let keyLastCompany = context.getters['setting_repository/keyLastCompany'];
            context.dispatch('setting_repository/setSettings', {settings: keyLastCompany, value: company.id});
          }
        },
        downloadExcel(context){
          return new Promise((resolve, reject) => {
            client.post('download_excel/', {'company_db_id':context.state.currentCompany.id}).then(resp => {
              let fileURL = window.URL.createObjectURL(new Blob([resp.data]));
              let fileLink = document.createElement("a");
    
              fileLink.href = fileURL;
              fileLink.setAttribute("download", "facturas.csv");
              document.body.appendChild(fileLink);
    
              fileLink.click();
              resolve()
            }).catch(err => {
              reject(err);
            })
          })
        },
        mergeDocuments(context, docs) {
          return new Promise((resolve, reject) => {
            let params = { 'ids': [] }
            for (let i in docs) {
              params['ids'].push(docs[i].id)
            }
            client.post('merge_documents/', params).then(resp => {
              resolve(resp);
            }).catch(err => {
              reject(err);
            })
          })
        },
        splitDocument(context, docs) {
          return new Promise((resolve, reject) => {
            let params = { 'id': docs[0].id }
            client.post('split_document/', params).then(resp => {
              resolve(resp);
            }).catch(err => {
              reject(err);
            })
          })
        },
        contabilizar({}, params) {
          return new Promise((resolve, reject) => {
            client.post('contabilizar/', params).then(resp => {
              resolve(resp);
            }).catch(err => {
              reject(err);
            });
          });
        },
        signOut: ({commit, dispatch}) =>
          new Promise((resolve, reject)=> {
            Auth.signOut().then(result=>{
              commit('SET_COMPANY_DBS', [])
              dispatch('setCurrentCompany', null)
              commit('SET_IS_LOGGED','no')  
              resolve(result)
            }).catch(reject)
        }),
        signInUser: ({commit, state}, cred) =>
          new Promise((resolve, reject)=> {
            commit('SET_IS_LOGGED_PROMISE', Auth.signIn(cred.username, cred.password))
            state.isLoggedPromise.then(user=>{
              // commit('SET_USER', user)
              resolve(user)
              // dispatch('fetchProfile',user).then(response=>{
              //   resolve(user)
              //   return response
              // }).catch(reject)
            }).catch(reject)
        }),
        signUpUser: (({dispatch}, cred) => {
          return new Promise((resolve, reject) => {
            axios.post(process.env.VUE_APP_API_ENDPOINT+'/signup/', cred).then(resp => {
              resolve(resp);
            }).catch(err => {
              reject(err);
            });
          });
        }),
        changePassword: (context, cred) =>
          new Promise((resolve, reject)=> {
            Auth.changePassword(context.state.session_information, cred.oldpassword, cred.password).then(()=>{
              // commit('SET_USER', user)
              resolve()
              // dispatch('fetchProfile',user).then(response=>{
              //   resolve(user)
              //   return response
              // }).catch(reject)
            }).catch(reject)
        }),
        refreshSession: (context) => 
          new Promise((resolve, reject) => {
            Auth.currentSession().then(session => {
              let headers = {'Authorization':'Bearer ' + session.idToken.jwtToken}
              setHeaders(headers)
              Auth.currentUserPoolUser()
                .then(user => {
                  context.commit('SET_SESSION_INFORMATION', user)
                  resolve(session)
                }).catch(reject)
            }).catch(reject)
          }),

        passwordResetUser: (({dispatch}, data) => {        
          return new Promise((resolve, reject) => {
            axios.post(process.env.VUE_APP_API_ENDPOINT+'/password_reset/', data).then(resp => {
              resolve(resp);
            }).catch(err => {
              reject(err);
            });
          });
        }),
        passwordResetkeyUser: (({dispatch}, data) => {          
          return new Promise((resolve, reject) => {
            axios.post(process.env.VUE_APP_API_ENDPOINT+'/password_reset_from_key/'+data['uidb36']+ '-' + data['key'] + '/', data).then(resp => {
              resolve(resp);
            }).catch(err => {
              reject(err);
            });
          });
        }),
        confirmEmailUser: (({dispatch}, data) => {          
          return new Promise((resolve, reject) => {
            client.post('sync_command_bus/', {'command':{cmd_name:'confirm.email.user', code:data['code']}}).then(resp => {
              resolve(resp);
            }).catch(err => {
              reject(err);
            });
          });
        }),
        resendConfirmationEmailUser: (({dispatch}, data) => {          
          return new Promise((resolve, reject) => {
            client.post('sync_command_bus/', {'command':{cmd_name:'resend.confirmation.email.user'}}).then(resp => {
              resolve(resp);
            }).catch(err => {
              reject(err);
            });
          });
        }),
        setJWTToken: (context, info) =>{
          context.commit('SET_SESSION_INFORMATION', info)
          let headers = {'Authorization':'Bearer ' + info.signInUserSession.idToken.jwtToken}
          setHeaders(headers)
          context.commit('SET_IS_LOGGED','yes');
    
          function refreshSession(){
            if(new Date(context.getters.getSessionInformation.signInUserSession.accessToken.payload.exp * 1000)<new Date()){
              context.dispatch("refreshSession");
            }
            setTimeout(refreshSession,1000);
          }
          setTimeout(refreshSession,1000);
    
        },
    
        setChoices(context) {
          return new Promise((resolve, reject) => {
            client.get('get_choices_fields/').then(response => {
              context.commit('SET_RETENTION_TYPES', response.data.retention_types);
              resolve();
            }).catch(error => { reject(error) });
          });
        },
        setDocRetentionTypes(context) {
          return new Promise((resolve, reject) => {
            client.get('get_retention_types_choices/').then(response => {
              context.commit('SET_DOC_RETENTION_TYPES', response.data.retention_types);
              resolve();
            }).catch(error => { reject(error) });
          });
        },
        setAutomaticPaymentAccountTypes(context)    
        {
          return new Promise((resolve, reject) => {
            client.get('get_payment_account_choices/')
              .then(response => {
                context.commit('SET_AUTOMATIC_PAYMENT_ACCOUNT_TYPES', response.data.automatic_payment_account_types);
                resolve()
              })
              .catch(error => { reject(error)});
          })
        },
    
        getObjectData(context, url) {
          return new Promise((resolve, reject) => {
            client.get(url).then(response => {
              resolve();
            }).catch(error => { reject(error) });
          });
        },
        setDashboardData(context, contract) {
          return new Promise((resolve, reject) => {
            let filter = '';
            if (contract) {
              filter = '?contract=' + contract;
            }
            client.get('get_dashboard/' + filter).then(response => {
              resolve(response);
            }).catch(error => { reject(error) });
          })
        },
        setLoginas(context, userUsername) {
          return new Promise((resolve, reject) => {  
            client.post('set_loginas/', {'logged_username': context.state.session_information.username, 'user_username': userUsername}).then(response => {
              resolve();
            }).catch(error => { reject(error) });
          })
        },
        unsetLoginas(context, parameters) {
          return new Promise((resolve, reject) => {
            client.post('unset_loginas/', parameters).then(response => {
              resolve();
            }).catch(error => { reject(error) });
          })
        },
        setLoginasDistributor(context, userUsername) {
          return new Promise((resolve, reject) => {
            client.post('set_loginas_distributor/', {'user_username': userUsername}).then(response => {
              resolve();
            }).catch(error => { reject(error) });
          })
        },
        changeTrainerMode(context) {
          return new Promise((resolve, reject) => {
            client.post('change_trainer_mode/').then(response => {
              resolve();
            }).catch(error => { reject(error) });
          })
        },
        changeDebuggerMode(context) {
          return new Promise((resolve, reject) => {
            client.post('change_debugger_mode/').then(response => {
              resolve();
            }).catch(error => { reject(error) });
          })
        },
        setSupplierRowsPerPage(context, rowsNumber) {  
          context.commit('SET_SUPPLIER_ROWS_PER_PAGE', rowsNumber);
        },
        setCustomerRowsPerPage(context, rowsNumber) {  
          context.commit('SET_CUSTOMER_ROWS_PER_PAGE', rowsNumber);
        },
    
        refreshData(context, filts) {
          if (context.state.currentCompany || context.state.objectListBaseUrl == 'companydbs/') {
            const { page, itemsPerPage, sortBy, sortDesc } = context.state.objectListOptions;
            let sortField = undefined;
            let sortOrder = undefined;
            if(sortBy){
              sortField = sortBy[0];
            }
            if(sortDesc){
              sortOrder = sortDesc[0];
            }
            if (itemsPerPage) {
              let offset = (page - 1) * itemsPerPage;
              context.commit('UNSELECT_OBJECT_LIST_SELECTED')
              context.commit('SET_OBJECT_LIST_LOADING', true);
              
              let filters = '?limit=' + itemsPerPage + '&offset=' + offset;
              if (context.state.objectListBaseUrl != 'companydbs/') {
                filters += '&company_id=' + context.state.currentCompany.id;
              }
              if (filts) {
                filters += filts;
              }
              if (sortField) {
                if(Object.keys(context.state.strange_order_fields).includes(sortField)){
                  sortField = context.state.strange_order_fields[sortField]
                }
                filters += '&ordering=';
                if (sortOrder) {
                  filters += '-';
                }
                filters += sortField;
              }
              var url = context.state.objectListBaseUrl + filters; 
              client.get(url).then(response => {        
                context.commit('SET_OBJECT_LIST_ITEMS', response.data.results);
                context.commit('SET_OBJECT_LIST_ITEMS_LENGTH', response.data.count);
                context.commit('SET_OBJECT_LIST_LOADING', false);
                context.commit('SET_TOTAL_LENGTH_ITEMS', response.data.total_count);
              });
              
            }
          }
        },
    
    
    
        resetFilters({ commit, state, dispatch, rootGetters }) {
          // commit('SET_BROWSER_FILTS', '')
          // for (let fv in state.browserFiltersValues) {
          //   if (state.browserFiltersValues[fv].value) {
          //     commit('SET_BROWSER_FILTERS_VALUE', {i :fv, value: ''})F
          //     if (state.browserFunctions.length) {
          //       state.browserFunctions[fv]('');
          //     }
          //   }
          // }
    
          commit("documents/CLEAN_FILTERS");
    
          commit("cru/CLEAN_ALL_FILTERS")
          
    
    
    
          dispatch("documents/setCurrentFilters", state.browserFilts);
          dispatch("documents/refreshData");      
          commit('SET_OBJECT_LIST_FILTERS', state.browserFilts);
    
          dispatch("refreshData", '');
        },
    
        setOauthUrl({commit},{url}){
          commit('SET_OAUTH_URL',url)
        },
        setOauthMsg({commit}, {msg}) {
          commit('SET_OAUTH_MSG', msg)
        },
        setOauthDataStorage({ commit ,dispatch}, oauth_params){
          return new Promise((resolve, reject) => {
            if(!oauth_params.params.hasOwnProperty("error")) {
              commit('SET_OAUTH_PARAMS_STORAGE', oauth_params);
            } 
            // const urlParams = new URLSearchParams(oauth_params.params);
            // let state = urlParams.get('state');
            const {params} = oauth_params;
            const state = params.state.split("|").pop().split(",")[0];
            resolve(state);
          });
        },
        changeCrispColor({},color){
          window.$crisp.push(["config", "color:theme", [color]])
        },
        copySettingsFromCdb({ rootGetters }, {settings_code, cdb_id, copy_cdb_from}){
          return new Promise((resolve, reject) => {
            if (cdb_id) {
              let url = 'settings/copy_setting/' + settings_code + '/' + rootGetters["me/userData"]['user'] + '/' + cdb_id + '/';
              let params = { 'cdb_id_from': copy_cdb_from};
              client.patch(url, params).then(resp => {
                resolve(resp.data);
              }).catch(err => {
                console.debug(err);
                reject(err);
              });
            } else {
              reject();
            }
          });
        },
        resumeAccounting({ dispatch }){
          return new Promise((resolve, reject) => {
            let params = { 'stop_accounting_manual': false };
            client.post('stop_accounting/', params).then(resp => {
              dispatch("me/forceRefreshUserData");
              resolve(resp.data);
            }).catch(err => {
              console.debug(err);
              reject(err);
            });
          });
        },
      },
    });
    
  }